import { render, staticRenderFns } from "./DynamicsIndicatorsList.vue?vue&type=template&id=3ad7cd3e&scoped=true&"
import script from "./DynamicsIndicatorsList.vue?vue&type=script&lang=js&"
export * from "./DynamicsIndicatorsList.vue?vue&type=script&lang=js&"
import style0 from "./DynamicsIndicatorsList.vue?vue&type=style&index=0&id=3ad7cd3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7cd3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
